import { useEffect, type ReactNode } from 'react';
import i18n from '../../i18n';

interface LanguageWrapperProps {
  lang: 'en' | 'nl';
  children: ReactNode;
}

export default function LanguageWrapper({ lang, children }: LanguageWrapperProps) {
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang).catch((error) => {
        // Optional: handle language change errors gracefully
        console.error('Failed to change language:', error);
      });
    }
  }, [lang]);

  return <>{children}</>;
}
